import React, { useEffect, useState } from 'react';
import { array, bool, shape, string } from 'prop-types';
import { withRouter } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

import { BLANK_RULE_TEMPLATE_ID, resetRule } from '../../helpers/rules';

const RuleTemplateSelect = ({
    disabled,
    error,
    history,
    location,
    onPatch,
    ruleTemplates,
    touched,
    value
}) => {

    const [ruleTemplateId, setruleTemplateId] = useState(() => {
        const params = new URLSearchParams(location.search);
        if (params.has('ruleTemplateId')) {
            return params.get('ruleTemplateId');
        }
        return BLANK_RULE_TEMPLATE_ID;
    });

    useEffect(() => {
        if (ruleTemplates.loading) {
            return;
        }
        setRule(ruleTemplateId);
    }, [ruleTemplates.loading, ruleTemplateId]);

    function handleChange(e) {
        if (!e) {
            return;
        }
        const ruleTemplateId = e.id;
        const params = new URLSearchParams(location.search);
        if (ruleTemplateId === BLANK_RULE_TEMPLATE_ID) {
            params.delete('ruleTemplateId');
        } else {
            params.set('ruleTemplateId', ruleTemplateId);
        }
        history.push({
            pathname: location.pathname,
            search:   `?${params.toString()}`
        });
        setruleTemplateId(ruleTemplateId);
    }

    function setRule(ruleTemplateId) {
        const rule = resetRule(ruleTemplateId, ruleTemplates);
        onPatch(rule);
    }

    return (
        <React.Fragment>
            <Autocomplete
                id="ruleTemplateId"
                options={ ruleTemplates && ruleTemplates.data ? [{ name: 'New Custom Rule', id: 0 }, ...ruleTemplates.data ] : [{ name: 'New Custom Rule', id: 0 }]}
                getOptionLabel={(option) => option.name}
                style={{ width: 300}}
                disabled={disabled}
                required
                onChange={(event, newValue) => {
                    handleChange(newValue);
                }}
                renderInput={(params) => 
                    <TextField
                        {...params}
                        label={ 
                            ruleTemplates.loading ? 
                                <React.Fragment>
                                    <span style={{paddingRight: '2rem'}}>{'Base Rule'}</span>
                                    <CircularProgress size={15} style={{position: 'absolute', right: 0 }} />
                                </React.Fragment> : 'Base Rule'
                        }
                    />}
            />
        </React.Fragment>
    );
};

RuleTemplateSelect.defaultProps = {
    disabled:      false,
    onPatch:       () => {},
    ruleTemplates: {
        data: []
    },
    touched: false
};

RuleTemplateSelect.propTypes = {
    error:    string,
    location: shape({
        search: string
    }),
    ruleTemplates: shape({
        data:    array,
        error:   string,
        loading: bool
    }),
    touched: bool,
    value:   string
};

export default withRouter(RuleTemplateSelect);
